import * as yup from "yup";
import { DocumentoRegex, TelefonoRegex } from "../utils/regex";

export const RepresentanteTecnicoSchema = yup.object().shape({
  nombre: yup
    .string()
    .max(100, "errors.representanteTecnico.nombre.max")
    .required("errors.representanteTecnico.nombre.required")
    .default(""),
  documento: yup
    .string()
    .matches(DocumentoRegex, "errors.representanteTecnico.documento.regex")
    .min(7, "errors.representanteTecnico.documento.min")
    .max(8, "errors.representanteTecnico.documento.max")
    .required("errors.representanteTecnico.documento.required")
    .default(""),
  cargo: yup
    .string()
    .max(100, "errors.representanteTecnico.cargo.max")
    .required("errors.representanteTecnico.cargo.required")
    .default(""),
  telefono: yup
    .string()
    .matches(TelefonoRegex, "errors.representanteTecnico.telefono.regex")
    .required("errors.representanteTecnico.telefono.required")
    .default(""),
  titulo: yup
    .string()
    .max(100, "errors.representanteTecnico.titulo.max")
    .required("errors.representanteTecnico.nombre.required")
    .default(""),
  correoElectronico: yup
    .string()
    .email("errors.representanteTecnico.correoElectronico.regex")
    .required("errors.representanteTecnico.correoElectronico.required")
    .default(""),
  matricula: yup
    .object()
    .shape({
      numero: yup
        .string()
        .max(20, "errors.representanteTecnico.matricula.numero.max")
        .required("errors.representanteTecnico.matricula.numero.required")
        .default(""),
      ente: yup
        .string()
        .max(70, "errors.representanteTecnico.matricula.ente.max")
        .required("errors.representanteTecnico.matricula.ente.required")
        .default(""),
    })
    .default({
      numero: "",
      ente: "",
    })
    .required("errors.representanteTecnico.matricula.numero.required"),
});

export function crearRepresentanteTecnico() {
  return RepresentanteTecnicoSchema.cast(undefined, { assert: false });
}
